'use client';

import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleX } from 'lucide-react';
import { useDeviceType } from '@/hooks/useIsMobile';
import { useToastStore } from '@/stores/useToastStore';
import IconAdaptive from '@/components/IconAdaptive';

export default function Toast() {
    const { isMobile, isTablet } = useDeviceType();
    const { message, type, show, hideToast } = useToastStore();

    const positionClass = isMobile || isTablet ? 'bottom-20' : 'top-4';

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ y: isMobile || isTablet ? 50 : -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: isMobile || isTablet ? 50 : -50, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className={clsx(
                        `fixed ${positionClass} inset-x-0 mx-auto z-[9999] px-6 py-3 rounded shadow-md text-sm font-bold w-fit max-w-[90%]`,
                        {
                            'bg-green-500 text-white': type === 'success',
                            'bg-red-500 text-white': type === 'error',
                            'bg-blue-500 text-white': type === 'info',
                            'bg-amber-500 text-white': type === 'systemError',
                        },
                    )}
                >
                    <div
                        className="flex items-center gap-4 font-corp font-medium text-sm cursor-pointer"
                        onClick={hideToast}
                    >
                        <span className="whitespace-pre-line">{message}</span>
                        <IconAdaptive
                            Icon={CircleX}
                            strokeWidth={2}
                            baseSize={20}
                            breakpoints={{ md: 20 }}
                            className="ml-2"
                        />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
